"use client";
import { useBreakpoints } from "@/hooks/useBreakpoints/useBreakpoints";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { useRef } from "react";
import { Typography } from "../../Typography/Typography.component";
import { StaticMaskPropsModel } from "./StaticMask.model";

const StaticMask = ({ className = "", title }: StaticMaskPropsModel) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useBreakpoints();

  return (
    <div
      className={cn("absolute top-0 left-0 h-full w-full", className)}
      ref={containerRef}
    >
      {!isMobile ? (
        <div className="relative h-full w-full">
          <Typography.H1 className="text-core-white absolute top-[50%] left-[20px]">
            {title}
          </Typography.H1>
          <Image
            className="h-full w-full"
            src="/static/img/static-mask-pc.png"
            alt="Static Mask"
            width={100}
            height={100}
            priority
          />
        </div>
      ) : (
        <div className="relative h-full w-full">
          <Typography.H1 className="text-core-white absolute top-[42%] left-[8px] max-w-[60%]">
            {title}
          </Typography.H1>
          <Image
            className="h-full w-full"
            src="/static/img/static-mask.png"
            alt="Static Mask"
            width={100}
            height={100}
            priority
          />
        </div>
      )}
    </div>
  );
};

export default StaticMask;
